module.exports = __webpack_public_path__ + "assets/img/768_main_img_carousel_2.b180b6f7.png";